module.exports = __webpack_public_path__ + "img/P39.ca107d41.png";